export default __webpack_public_path__ + "static/media/ExpertDataset.023d274f.csv";